import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
export function Footer() {
  const certifications = [{
    src: 'https://cdn.magicpatterns.com/uploads/dNexntwFHMkm7ZPkJVXEbM/iso-9001-certified.jpg',
    alt: 'ISO 9001'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/gpDeLGDsven44JSBqjzPBx/ISO_14001.jpg',
    alt: 'ISO 14001'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/osdWtkSKVjaRAt7iCy6kEa/Joscar.png',
    alt: 'JOSCAR'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/6FuydEZynCq18cGM9hgcSz/Cyber.jpg',
    alt: 'Cyber Essentials'
  }];
  return <footer className="bg-[#0A1628] pt-20 pb-10 border-t border-white/5" data-id="element-130">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12" data-id="element-131">
        {/* Main Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-x-10 gap-y-12 mb-16" data-id="element-132">
          {/* Company Info */}
          <div className="col-span-2" data-id="element-133">
            <img src="https://cdn.magicpatterns.com/uploads/q9rehXWKJNRy1KSyHWnt8x/ILN_Logo.png" alt="Industrial Labels & Nameplates" className="h-14 w-auto brightness-0 invert mb-6" data-id="element-134" />
            <div className="space-y-3 text-sm text-slate-400 mb-6" data-id="element-135">
              <div className="flex items-start gap-3" data-id="element-136">
                <MapPin className="h-4 w-4 text-slate-500 mt-0.5 flex-shrink-0" data-id="element-137" />
                <address className="not-italic leading-relaxed" data-id="element-138">
                  Industrial Labels & Nameplates
                  <br data-id="element-139" />
                  Town Works
                  <br data-id="element-140" />
                  Washington Street Industrial Estate
                  <br data-id="element-141" />
                  Cradley Road
                  <br data-id="element-142" />
                  Dudley
                  <br data-id="element-143" />
                  DY2 9PH
                </address>
              </div>
              <p className="flex items-center gap-3" data-id="element-144">
                <Phone className="h-4 w-4 text-slate-500 flex-shrink-0" data-id="element-145" />
                01384 243155
              </p>
              <p className="flex items-center gap-3" data-id="element-146">
                <Mail className="h-4 w-4 text-slate-500 flex-shrink-0" data-id="element-147" />
                sales@industriallabelsandnameplates.co.uk
              </p>
            </div>
          </div>

          {/* Products */}
          <div data-id="element-148">
            <h3 className="text-white font-semibold text-sm mb-5 uppercase tracking-wider" data-id="element-149">
              Products
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-150">
              {['Asset labels', 'Nameplates', 'Security labels', 'Logo labels', 'Custom labels'].map(item => <li key={item} data-id="element-151">
                  <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-152">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Customer Service */}
          <div data-id="element-153">
            <h3 className="text-white font-semibold text-sm mb-5 uppercase tracking-wider" data-id="element-154">
              Support
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-155">
              {['Delivery information', 'Returns policy', 'Request a quote', 'Request samples', 'Track your order', 'FAQs'].map(item => <li key={item} data-id="element-156">
                  <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-157">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-158">
            <h3 className="text-white font-semibold text-sm mb-5 uppercase tracking-wider" data-id="element-159">
              Company
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-160">
              {[{
              label: 'About us',
              href: '/about'
            }, {
              label: 'Sectors',
              href: '/services'
            }, {
              label: 'Contact',
              href: '#'
            }, {
              label: 'Careers',
              href: '#'
            }, {
              label: 'Sustainability',
              href: '#'
            }].map(item => <li key={item.label} data-id="element-161">
                  <a href={item.href} className="text-slate-400 hover:text-white transition-colors" data-id="element-162">
                    {item.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Certifications */}
          <div data-id="element-163">
            <h3 className="text-white font-semibold text-sm mb-5 uppercase tracking-wider" data-id="element-164">
              Certified
            </h3>
            <div className="flex flex-wrap items-center gap-3" data-id="element-165">
              {certifications.map((cert, index) => <div key={index} className="w-16 h-12 bg-white rounded-lg flex items-center justify-center p-1.5" data-id="element-166">
                  <img src={cert.src} alt={cert.alt} className="max-w-full max-h-full object-contain" data-id="element-167" />
                </div>)}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center pt-8 border-t border-white/10 gap-4" data-id="element-168">
          <div className="text-sm text-slate-500" data-id="element-169">
            <p data-id="element-170">© 2026 Industrial Labels & Nameplates. All rights reserved.</p>
            <p className="text-xs text-slate-600 mt-1" data-id="element-171">
              Industrial Labels & Nameplates is a trading name of The Label
              Centre Limited.
            </p>
          </div>
          <div className="flex gap-6 text-sm text-slate-500" data-id="element-172">
            <a href="#" className="hover:text-slate-300 transition-colors" data-id="element-173">
              Privacy policy
            </a>
            <a href="#" className="hover:text-slate-300 transition-colors" data-id="element-174">
              Terms & conditions
            </a>
            <a href="#" className="hover:text-slate-300 transition-colors" data-id="element-175">
              Cookie policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}